<template>
  <v-dialog
    v-model="showDialog"
    persistent
    max-width="900px"
  >
    <v-card>
      <v-card-text>
        <form-asset-input :document-ref="getDocumentRef()" />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          small
          @click.stop="send()"
        >
          Next
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getRootCollection } from '@/dataAccess/queries'
import FormAssetInput from '@/components/FormAssetInput'

export default {
  name: 'CaptureAssetDataDialog',
  components: { FormAssetInput },
  props: {
    showDialog: { type: Boolean, default: false },
    docData: { type: Object, default: null }
  },
  data: function () {
    return {
      documentRef: null
    }
  },
  methods: {
    getDocumentRef() {
      return getRootCollection('documents').doc(this.docData.documentId)
    },
    async send() {
      if (!(this.docData && this.docData.documentId)) {
        this.$showErrorbar('Error sending document for signature')
        return
      }

      const { documentId: id, name, counterparty } = this.docData
      this.$handlingError(`Error sending document ${name}`, async () => {
        this.$emit('cancelClick')
        this.$router.push('/dashboard')
        await this.$api.sendForSignature({ id, counterparty })
      })
    }
  }
}
</script>
